<div *ngIf="(vm$ | async) as vm">
    <div *ngIf="vm.ticket">
        <app-table-data [hostOptions]="vm.hostOptions" [layoutOptions]="vm.layoutOptions"></app-table-data>    
    </div>
    <div *ngIf="!vm.ticket">
        <span>no ticket</span>
    </div>
</div>
